import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['Martín', 'Gustavo', 'Luciana', 'Diego', 'Romina', 'Carlos', 'María', 'Pablo', 'Alejandra', 'Fernando', 'Sofía', 'Nicolás', 'Valentina', 'Sebastián', 'Camila'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 10000);
    // Then random intervals between 15s and 25s
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * 10000) + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-208">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-truco-surface border border-truco-gold/30 shadow-2xl rounded-lg p-4 max-w-sm flex items-start gap-3" data-id="element-209">
          <div className="bg-truco-dark p-2 rounded-md border border-truco-gold/20 text-2xl" data-id="element-210">
            🃏
          </div>
          <div data-id="element-211">
            <p className="text-sm text-truco-cream font-medium" data-id="element-212">
              <span className="text-truco-gold font-bold" data-id="element-213">
                {currentBuyer.name}
              </span>{' '}
              de {currentBuyer.city} acaba de comprar
            </p>
            <p className="text-xs text-truco-creamMuted mt-1" data-id="element-214">
              La Biblia del Truco Argentino
            </p>
            <p className="text-[10px] text-truco-gold/60 mt-2" data-id="element-215">
              Hace unos segundos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}